import type {ScreenplayTextSize} from './screenplayTextSize';
export const SCRIPT_ZOOM_KEY='tableread.editor.script-zoom.v1';
export const TOOLS_COLLAPSED_KEY='tableread.editor.tools-collapsed.v1';
export const MIN_SCRIPT_ZOOM=50,MAX_SCRIPT_ZOOM=200,DEFAULT_SCRIPT_ZOOM=100;
export const SCRIPT_ZOOM_PRESETS=[50,75,90,100,110,125,150,175,200] as const;
export const clampScriptZoom=(value:number)=>Math.max(MIN_SCRIPT_ZOOM,Math.min(MAX_SCRIPT_ZOOM,Math.round(Number.isFinite(value)?value:DEFAULT_SCRIPT_ZOOM)));
export function savedScriptZoom(){
 try{const raw=localStorage.getItem(SCRIPT_ZOOM_KEY);if(raw!==null&&raw.trim()&&Number.isFinite(Number(raw)))return clampScriptZoom(Number(raw));}catch{/* Browser preferences are optional. */}
 return DEFAULT_SCRIPT_ZOOM;
}
export function savedToolsCollapsed(){try{return localStorage.getItem(TOOLS_COLLAPSED_KEY)==='true';}catch{return false;}}
export function scriptZoomMetrics(size:ScreenplayTextSize,zoom:number){
 const [font,line]=size==='small'?[12,16]:size==='large'?[16,24]:[14,20];
 const ratio=clampScriptZoom(zoom)/100;return{fontSize:font*ratio,lineHeight:line*ratio};
}
